/*jshint 
bitwise:true, curly:true, eqeqeq:true, forin:true, immed:true, latedef:true, newcap:true, 
noarg:true, noempty:true, nonew:true, plusplus:true, regexp:true, undef:true, trailing:true,
browser:true, jquery:true, devel:true, maxlen:200, onevar:false */
/*global AppFrame: false, EastPane: false, iFirmLayout: false, iFirmPageLayout: false */
/*global angular: false */

var ifirmAppFrameModule = angular.module('ifirmAppFrameModule', []);

// Here so that this function can be used in both native & angularjs apps
var reloadUtils = (function () {
    var centerCallback = null;
    var southCallback = null;
    var northCallback = null;
    var clientLookupDialog = null;
    var screenVersion = "1.0";
    return {
        reload: function (cultureName) {

            if (centerCallback) {
                centerCallback(cultureName);
            }

            if (southCallback) {
                southCallback(cultureName);

                // Remove once 2.0 client lookup is used exclusivly
                // Reset client lookup on refresh
                if (typeof clientLookupDialog != 'undefined') {
                    console.log("ClientLookup", clientLookupDialog);
                    if (clientLookupDialog) {
                        clientLookupDialog.remove();
                        clientLookupDialog = null;
                        clientLookupDiv = null;
                        clientSearchDiv = null;
                        clientIsFirst = true;
                    }
                }
            }

            if (northCallback) {
                northCallback(cultureName);
            }
        },

        setCenterReload: function (callback, angular) {
            var version = '';
            screenVersion = "1.0";

            if (callback) {
                if (angular) {
                    version = "2.0";
                    screenVersion = "2.0";
                }
                else {
                    version = "1.5";
                    screenVersion = "1.5";
                }
            }

            $('.mlversion').text(version);

            centerCallback = callback;
        },

        setSouthReload: function (callback) {
            southCallback = callback;
        },

        setNorthReload: function (callback) {
            northCallback = callback;
        },

        getScreenVersion: function () {
            return screenVersion;
        }

    };
}());


ifirmAppFrameModule.factory('appFrameManager', [function () {
    return {
        reload: function (cultureName) {
            reloadUtils.reload(cultureName);
        },

        setCenterReload: function (callback) {
            reloadUtils.setCenterReload(callback, true);
        },

        setSouthReload: function (callback) {
            reloadUtils.setSouthReload(callback);
        },

        setNorthReload: function (callback) {
            reloadUtils.setNorthReload(callback);
        },

        setBreadcrumb: function (text, showbreadcrumb, breadcrumbs, removeHtml) {
            if (typeof AppFrame === 'object') {
                AppFrame.SetupBreadcrumbs(text, 'force', null, null, showbreadcrumb, breadcrumbs, removeHtml);
            }
        },

        setBreadcrumbResourceId: function (id, params) {
            if (typeof AppFrame === 'object') {
                AppFrame.SetupBreadcrumbs('', 'resourceid', id, params);
            }
        },

        setBreadcrumbStatus: function (text) {
            if (typeof AppFrame === 'object') {
                AppFrame.AddBreadcrumbInfo(text, 'force');
            }
        },

        showEastPane: function (url) {
            if (url) {
                if (typeof EastPane === 'object') {
                    EastPane.Init(url, true);
                }
            }
            else {
                if (typeof iFirmLayout === 'object') {
                    iFirmLayout.hide('east');
                }
            }
        },

        showTitle: function (show) {
            if (typeof iFirmPageLayout === 'object') {
                if (show) {
                    iFirmPageLayout.show('north');
                }
                else {
                    iFirmPageLayout.hide('north');
                }
            }
        },

        bindToPageChanged: function (callback) {
            if (typeof AppFrame === 'object') {
                AppFrame.BindToPageChanged(callback);
            }
        },

        showMenu: function (show) {
            if (typeof iFirmLayout === 'object') {
                if (show) {
                    iFirmLayout.show('west');
                }
                else {
                    iFirmLayout.hide('west');
                }
            }
        },

        closeMenu: function (open) {
            if (typeof iFirmLayout === 'object') {
                if (open) {
                    iFirmLayout.open('west');
                }
                else {
                    iFirmLayout.close('west');
                }
            }
        },

        showSpinner: function ()
        {
            if (typeof AppFrame === 'object') {
                AppFrame.ShowSpinner();
            }
        },

        hideSpinner: function () {
            if (typeof AppFrame === 'object') {
                AppFrame.HideSpinner();
            }
        },
    
        getAllUrlVariables: function () {
            if (typeof AppFrame === 'object') {
                return AppFrame.GetAllUrlVariables() || {};
            }
        },

        addStateAndUpdateAddressHash: function (state) {
            if (typeof AppFrame === 'object') {
                AppFrame.AddStateAndUpdateAddressHash(jQuery.param(state));
            }
        },

        startsWith: function (part) {
            if (typeof AppFrame === 'object') {
                return AppFrame.GetAnchorFromLocation(location.href).toLowerCase().startsWith(part);
            }
        },

        bindToPageChanged: function (callback) {
            if (typeof AppFrame === 'object') {
                AppFrame.BindToPageChanged(callback);
            }
        },

        addNorthHeight: function (change) {
            if (iFirmLayout) {
                iFirmLayout.sizePane('north', iFirmLayout.state.north.size + change);
            }
        }

    };
}]);